import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eKyHieuHoaDonActionIds,
  IKyHieuHoaDonActionTypes,
} from "../../action-types/hoa-don/IKyHieuHoaDonAction";
import { rootActions } from "../../actions/rootActions";
import { IKyHieuHoaDon } from "../../../model/respone/hoa-don-dien-tu/IKyHieuHoaDon";
import { kyHieuHoaDonApi } from "../../../api/hoa-don/kyHieuHoaDonApi";

export function* kyHieuHoaDonSaga(): any {
  yield takeLatest(eKyHieuHoaDonActionIds.LOAD_START, loadWorker);
  yield takeEvery(eKyHieuHoaDonActionIds.SAVE_START, saveWorker);
  yield takeEvery(eKyHieuHoaDonActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(kyHieuHoaDonApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.hoaDon.kyHieuHoaDon.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.hoaDon.kyHieuHoaDon.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}
function* saveWorker(action: IKyHieuHoaDonActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IKyHieuHoaDon;
  if (payload.id > 0) {
    res = yield call(kyHieuHoaDonApi.Update, payload);
  } else {
    res = yield call(kyHieuHoaDonApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.hoaDon.kyHieuHoaDon.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.hoaDon.kyHieuHoaDon.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* deleteWorker(action: IKyHieuHoaDonActionTypes): any {
  const res: IBaseRespone = yield call(
    kyHieuHoaDonApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.hoaDon.kyHieuHoaDon.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.hoaDon.kyHieuHoaDon.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}
